// src/components/store/sections/gallery/GalleryV93MasonrygridSlateGold.tsx
"use client";

import React from "react";
import DynamicGalleryVariant from "./DynamicGalleryVariant";

export default function GalleryV93MasonrygridSlateGold(props: any) {
  return (
    <DynamicGalleryVariant
      variantNumber={93}
      archKey="masonry_grid"
      archLabel="Dynamic Masonry"
      palName="SlateGold"
      grad="from-slate-800 via-zinc-900 to-neutral-950"
      lightBg="bg-amber-50/80"
      textCol="text-amber-700"
      borderCol="border-amber-300"
      btnCls="bg-slate-900 hover:bg-slate-800"
      hexCol="#eab308"
      {...props}
    />
  );
}
